var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuardTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 248,
    viewBox: "0 0 168 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.453 32.0816L108.069 1.25916C106.397 0.731323 104.603 0.731323 102.931 1.25916L5.54687 32.0816C2.23579 33.1296 0 36.0731 0 39.3904V147.269C0 213.703 98.7318 245.716 102.931 247.045C103.767 247.311 104.632 247.442 105.5 247.442C106.368 247.442 107.233 247.311 108.069 247.045C112.268 245.716 211 213.703 211 147.269V39.3904C211 36.0731 208.764 33.1296 205.453 32.0816Z",
    fill: "url(#paint0_linear_1_54)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_54",
    x1: 12.5,
    y1: 233.667,
    x2: 173.682,
    y2: 6.26653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardTop);
export default __webpack_public_path__ + "static/media/guard-top.a38347a8a61addad51d1075a6664acdc.svg";
export { ForwardRef as ReactComponent };